'use client'

import { useEffect, useState } from 'react'
import ProductCard from '@/entities/ProductCard'
import {
    AddToCart,
    AddToPreferences,
    QuickView,
} from '@/features/productSearch/ProductCardActions'
import {
    useGetCartItemsQuery,
    useGetOtherProductsMutation,
} from '@/shared/api-rtk/index.js'

export const ResemProducts = ({ title, product }) => {
    const [itemsResem, setItemsResem] = useState([])
    const [getOtherProducts] = useGetOtherProductsMutation()

    const { data: productsInCart } = useGetCartItemsQuery()

    useEffect(() => {
        getOtherProducts(product.product_id)
            .unwrap()
            .then((res) => {
                if (res.result === 'success') {
                    setItemsResem(Object.values(res.data))
                }
            })
    }, [])

    return (
        <div className={'ResemProducts'}>
            <h2>{title}</h2>
            {itemsResem && (
                <div className={'items-container'}>
                    {itemsResem.map((item) => {
                        return (
                            <ProductCard {...item} key={item.product_id}>
                                <QuickView productId={item.product_id} />
                                <AddToPreferences
                                    item={item}
                                    productId={item.product_id}
                                />
                                <AddToCart
                                    item={item}
                                    productId={item.product_id}
                                    cartContains={productsInCart?.data?.includes(
                                        item.product_id
                                    )}
                                />
                            </ProductCard>
                        )
                    })}
                </div>
            )}
        </div>
    )
}
